import { Box, Link, Typography } from "@mui/material";

import { Button, Modal } from "@covertree/ui";

import { AGENT_HELP_ADDRESS } from "@consts/index";

interface EndorsementInProgressModalProps {
  readonly isModalOpen: boolean;
  readonly onClose: () => void;
}

export function EndorsementInProgressModal({
  isModalOpen,
  onClose,
}: EndorsementInProgressModalProps) {
  return (
    <Modal
      open={isModalOpen}
      onClose={onClose}
      title="Endorsement In Progress"
      maxWidth={false}
      sx={{
        width: { xs: "80%", md: 720 },
        "&:focus": {
          outline: "none",
        },
      }}>
      <Typography variant="h5" sx={{ pr: 5, textAlign: "justify" }}>
        An endorsement is currently in progress for this policy.
        <br />
        Your request with the updated information has been sent to{" "}
        <Link color="secondary" href={`mailto:${AGENT_HELP_ADDRESS}`}>
          {AGENT_HELP_ADDRESS}
        </Link>{" "}
        to update the existing endorsement.
      </Typography>
      <Box mt={4} columnGap={3} display="flex">
        <Button onClick={onClose}>Close</Button>
      </Box>
    </Modal>
  );
}
